module.exports = __webpack_public_path__ + "img/icon-search-button.73e7f29e.svg";